import { render, staticRenderFns, recyclableRender, components } from "./dash-countTo.vue?vue&type=template&id=0e0971e4&"
var renderjs
import script from "./dash-countTo.vue?vue&type=script&lang=js&"
export * from "./dash-countTo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_@dcloudio_vue-cli-plugin-uni@2.0.0-28320200727001@@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null,
  false,
  components,
  renderjs
)

component.options.__file = "components/dash-countTo/dash-countTo.vue"
export default component.exports